// Third-party
import React from 'react';
import { FormattedMessage as ReactIntlFormattedMessage } from 'react-intl';

// Utils
import { formatMessageWithLocale } from './i18n';
import Dictionary from '@/types/dictionary';
import Locale from '@/types/locale';

type Props = {
  id: string;
  values?: Dictionary<string | number>;
  defaultMessage?: string;
  tagName?: keyof React.JSX.IntrinsicElements;
  locale?: Locale;
};

const FormattedMessage = ({ locale, id, values, defaultMessage, tagName = 'span' }: Props) => {
  if (locale) {
    const content = formatMessageWithLocale(id, locale, values, defaultMessage);
    return React.createElement(tagName, null, content);
  }

  const msg = <ReactIntlFormattedMessage id={id} values={values} defaultMessage={defaultMessage} />;
  return React.createElement(tagName, null, msg);
};

export default FormattedMessage;
